export default function InitProductDetails() {
    const features = [...document.querySelectorAll('.ng-product-features .ng-feature-list details')];
    if (!features.length || typeof Element.prototype.animate !== 'function') return;

    const motionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');
    const finishAnimations = features.map(details => {
        const summary = details.querySelector('summary');
        const content = details.querySelector('.ng-feature-content');
        let animation = null;

        summary.setAttribute('aria-expanded', String(details.open));
        content.inert = !details.open;

        function cancelAnimation() {
            if (!animation) return;
            animation.onfinish = null;
            animation.cancel();
            animation = null;
        }

        function finish() {
            details.open = summary.getAttribute('aria-expanded') === 'true';
            content.inert = !details.open;
            cancelAnimation();
        }

        // Native summary activation also emits click for Enter and Space.
        summary.addEventListener('click', event => {
            event.preventDefault();
            const expanded = summary.getAttribute('aria-expanded') !== 'true';
            // Capture the rendered frame before cancellation to reverse without jumping.
            const height = details.open ? content.getBoundingClientRect().height : 0;
            const opacity = details.open ? Number(getComputedStyle(content).opacity) : 0;
            cancelAnimation();
            summary.setAttribute('aria-expanded', String(expanded));
            content.inert = !expanded;

            if (motionPreference.matches) {
                finish();
                return;
            }

            // Keep the disclosure open until its closing animation has finished.
            details.open = true;
            animation = content.animate([
                { height: `${height}px`, opacity },
                { height: `${expanded ? content.scrollHeight : 0}px`, opacity: expanded ? 1 : 0 },
            ], { duration: 280, easing: 'cubic-bezier(.22,1,.36,1)', fill: 'both' });
            animation.onfinish = finish;
        });

        return () => { if (animation) finish(); };
    });

    const settleAnimations = () => finishAnimations.forEach(finish => finish());
    window.addEventListener('resize', settleAnimations);
    window.addEventListener('beforeprint', settleAnimations);
    motionPreference.addEventListener('change', () => {
        if (motionPreference.matches) settleAnimations();
    });
}
